"use client";

import { getGasPrice } from "@wagmi/core";
import { useCallback, useState } from "react";
import { formatGwei, parseGwei } from "viem";
import { useConfig } from "wagmi";

// Threshold in gwei - above this is considered "high"
export const HIGH_GAS_THRESHOLD_GWEI = BigInt(50);

export interface GasPriceCheckResult {
  isHighGas: boolean;
  gasPriceGwei: string;
  gasPriceWei: bigint;
}

export const useGasPriceCheck = (thresholdGwei = HIGH_GAS_THRESHOLD_GWEI) => {
  const [isChecking, setIsChecking] = useState(false);
  const config = useConfig();

  const checkGasPrice = useCallback(async (): Promise<GasPriceCheckResult> => {
    setIsChecking(true);
    try {
      const gasPrice = await getGasPrice(config);
      const gasPriceGwei = formatGwei(gasPrice);
      const thresholdWei = parseGwei(thresholdGwei.toString());

      return {
        isHighGas: gasPrice > thresholdWei,
        gasPriceGwei,
        gasPriceWei: gasPrice,
      };
    } finally {
      setIsChecking(false);
    }
  }, [thresholdGwei, config]);

  return {
    checkGasPrice,
    isChecking,
  };
};
